import { styled, TextField } from "@mui/material";
import RadioBox from "Components/FormControl/RadioBox/RadioBox";
import Select from "Components/FormControl/Select/NewSelect";
import DatePickerWithInput from "Components/NewOrder/DatePicker/DatePickerWithInput";
import { OrderConfigContext } from "Context/OrderConfigContext";
import { useFormikContext } from "formik";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Datetime from "react-datetime";
import { useOrderAttributeProvider } from "../context/order";
import { useDelivery } from "../hooks/useDelivery";
import {
  CUSTOM_ANYTIME,
  CUSTOM_DEFAULT_TIME,
  utcDateTimeToPSTTime,
  utctimeToPSTTime,
  validateNotAllowStoreOrder,
} from "../utility/util";
import Text from "Components/FormControl/Text/Text";
import {storeList} from "../../../../api/stores";
import { PAYMENT_METHOD_DETAIL, ORDER_SOURCE, PAYMENT_METHODS, TIME_ZONE_OFFSET, DEFAULT_TIMEZONE, DEFAULT_STORE_ID } from "Helpers/Constants";
import { AppContext } from "Context/AppContext";
import { useDeliveryAddress } from "Context/DeliveryAddress/usedeliveryAddress";
import Warning from "Components/Modal/Warning/warning";
// import { getDeliveryAddressInfo } from "../hooks/useLoqate";
const useStyles = styled({
  time: {
    paddingTop: "16px",
    marginBottom: "16px",
  },
});

const Delivery = () => {
  const config = useContext(OrderConfigContext);
  const [storeLists, setStoreList] = useState([]);
  useEffect(()=>{
    // Display stores which are assigned to the user
    let storelist = localStorage.getItem("assignStore");
      setStoreList(JSON.parse(storelist))
  },[])
  const classes = useStyles();
  const orderDelivery = [
    { id: "Before", title: "Before" },
    { id: "Anytime", title: "AnyTime" },
    { id: "After", title: "After" },
    { id: "By", title: "By" },
  ];

  const orderDeliveryWithOutAnytime = [
    { id: "Before", title: "Before" },
    { id: "After", title: "After" },
    { id: "By", title: "By" },
  ];

  const formik = useFormikContext();
  const {
    show,
    handleDateChange,
    handleDeliveryType,
    handleTimeChange,
    blockoutDates,
    tooltipDays,
    matrix,
    setMatrix,
    handleDeliveryMatrix,
    enableTimeEdit,
    setEnableTimeEdit,
    handleDeliveryChargeChange,
    setTimeslectionDropdown,
    handleDeliveredBy,
    timeslectionDropdown
  } = useDelivery();

  const { showToastMessage, setIsLoading } = useContext(AppContext);
  const { setDeliveryAddress,deliveryAddressState } = useDeliveryAddress();

  let tempDataFormik = formik.values.delivery_information.charge ? formik.values.delivery_information.charge : 0;
  const [tempCharge, setTempCharge] = useState(tempDataFormik);

  const { active, module } = useOrderAttributeProvider();
  // selected store list
  const [selectedStore, setSelectedStore] = useState([]);
  const [showModel, setShowModel] = useState(false);

  useEffect(() => {
    setTempCharge(tempDataFormik);
  }, [tempDataFormik]);

  useEffect(() => {
    handleDeliveryChargeChange(parseFloat(tempCharge));
  }, [tempCharge]);

  const isvalidateNotAllowStoreOrder = (payment_method, paypoint, storeId)=>{
    const validateNotAllowStores = validateNotAllowStoreOrder(payment_method, paypoint, storeId)
    if(validateNotAllowStores){
      showToastMessage(
        undefined,
        "Currently, we are not accepting online orders for the selected location. However, we will start soon.", 
        "error", 
        false
      );
      const defaultStore = config.storeList.find((store) => store.id === deliveryAddressState.storeId);
      formik.setValues((v) => ({
        ...v,
        delivery_information: {
          ...v.delivery_information,
          storeId: deliveryAddressState.storeId
        },
        billing_info: {
          ...v.billing_info,
          zip_code_store_id: deliveryAddressState.storeId,
          payment_method: PAYMENT_METHOD_DETAIL[deliveryAddressState.storeId] ? PAYMENT_METHOD_DETAIL[deliveryAddressState.storeId] : PAYMENT_METHODS.PAYABLI
        },
        payabli_paypoint: defaultStore.payabli_paypoint,
        payment_type: module === "edit-order" || module === "replace-order" ? v.payment_type : "",
        orderTimezone: defaultStore.timezone || DEFAULT_TIMEZONE
      }));
      return;
    }
  }

// we are Manage Order Transection data and filter 0 order id transection
  const order_payment_transactions_data =  formik.values?.order_payment_transactions?.filter((val) => val.order_id === 0) || []
  const payment_method = order_payment_transactions_data?.length > 0 && order_payment_transactions_data[0]?.payment_method
  const isDisebled = formik.values.source === ORDER_SOURCE.WALKIN.toLowerCase() && payment_method === PAYMENT_METHODS.PAYABLI ? true : false
  const deliveryInformation = formik.values.delivery_information;
  const isNonlocalZipcode = deliveryInformation.zipcode.length === 5 && deliveryInformation.is_local === 0 ? true : false

  //Reset delivery information when order type change pickup to delivery
  //And also update the order details according to the selected store
  const resetDeliveryInformation = () => {
    formik.setValues((v) => ({
      ...v,
      delivery_information: {
        ...v.delivery_information,
        address_type_id:null,
        attn: "",
        address_type: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        state: "",
        zipcode: "",
        order_type: 0,
        delivery_time: "",
        charge: 0,
        upcharge_id: 0,
        upcharge_amount: 0,
        delivery_type_id: 2,
        delivery_type: config?.deliveryTypesList?.find((c) => c.id === 2)?.name ?? "",
        delivery_date: null,
        delivery_time_id: null,
        delivery_date_time: "",
        storeId: v.billing_info.zip_code_store_id || 0
      },
      //PAYABLI
      billing_info: {
        ...v.billing_info,
        // zip_code_store_id: null,
        payment_method: "",
      },
      payment_type: module === "edit-order" || module === "replace-order" ? v.payment_type : "",
      payabli_paypoint:null,
      is_initial_load: false
    }));
    //Update latest delivery information in delivery address context
    setDeliveryAddress(formik.values.delivery_information);
  }

  const validateDeliveryDateSelection = async (storeId, day, time) => {
    const deliveryInfo = formik.values.delivery_information;
    const isValidTime = moment(time, "HH:mm", true).isValid();
    if (storeId && day && isValidTime) {
      const selectedDate = moment(day).format("YYYY-MM-DD");
      const storesList = await storeList();
      const storeDetails = storesList?.data?.data?.rows?.find(
        (store) => store.id === storeId
      );

      //if store not found then return true
      if (!storeDetails) {
        setIsLoading(false);
        return true;
      }

      //get delivery day
      const deliveryDay = moment(selectedDate, "YYYY-MM-DD").format("dddd");

      //get selected store Details and store open-close time
      const selectedStoreOpenCloseHours =
        storeDetails?.store_settings_openclose_times?.find(
          (elem) => elem.key === deliveryDay
        );

      //check if store open or not, if store close then return false
      if (selectedStoreOpenCloseHours.is_closed) {
        setShowModel(true);
        return false;
      } else if (deliveryInfo.order_type === 0) {
        // For delivery order
        return true;
      }

      //Store address for loqate API payload
      // const storeFullAdrdress = {
      //   Address1: storeDetails?.address1,
      //   Address2: storeDetails?.address2,
      //   Country: storeDetails?.country,
      //   PostalCode: storeDetails?.zip,
      //   SuperAdministrativeArea: storeDetails?.city,
      //   AdministrativeArea: storeDetails?.state,
      // };
      setIsLoading(true);
      //get delivery address info and timezone offset from loqate
      // const addressInfo = await getDeliveryAddressInfo(storeFullAdrdress);

      //Get delivery address timezone offset
      // const selectedStoreTimezone =
      //   addressInfo?.Matches[0]?.TimeZone_DST ?? TIME_ZONE_OFFSET;

      // const timeZoneHours = Number(selectedStoreTimezone?.split(":")[0]);
      // const timeZoneMinutes = Number(selectedStoreTimezone?.split(":")[1]);

      //Close bussiness hours
      const storeCloseTime = selectedStoreOpenCloseHours?.close_value;

      //Open bussiness hours
      const storeOpenTime = selectedStoreOpenCloseHours?.open_value;

      //Get customer selected delivery date time based on delivery time and delivery date
      const deliveryDateTime = moment(
        `${selectedDate} ${time}`,
        "YYYY-MM-DD HH:mm"
      ).format("YYYY-MM-DD HH:mm");

      //Convert store close time to timezone offset time based on address timezone
      const convertedStoreCloseTime = moment.utc(storeCloseTime, "HH:mm:ss")
        .tz(storeDetails.timezone || DEFAULT_TIMEZONE)
        .format("HH:mm:ss");

      //Inject store close time to delivery date and generate delivery date time in store timezone date-time based on that
      // const convertedStoreCloseDateTime = dateTimeFormat(convertedStoreCloseTime, "HH:mm:ss", deliveryInfo.delivery_date);
      const convertedStoreCloseDateTime = moment(
        `${selectedDate} ${convertedStoreCloseTime}`,
        "YYYY-MM-DD HH:mm:ss"
      ).format("YYYY-MM-DD HH:mm");

      //Convert store open time to PST timezone based on store timezone
      const convertedStoreOpenTime = moment.utc(storeOpenTime, "HH:mm:ss")
        .tz(storeDetails.timezone || DEFAULT_TIMEZONE)
        .format("HH:mm:ss");

      //Inject store open time to delivery date and generate delivery date time in PST timezone based on that
      const convertedStoreOpenDateTime = moment(
        `${selectedDate} ${convertedStoreOpenTime}`,
        "YYYY-MM-DD HH:mm:ss"
      ).format("YYYY-MM-DD HH:mm");

      if (
        deliveryDateTime < convertedStoreCloseDateTime &&
        deliveryDateTime > convertedStoreOpenDateTime
      ) {
        setIsLoading(false);
        setShowModel(false);
        return true;
      } else {
        setShowModel(true);
        setIsLoading(false);
        return false;
      }
    }
  };

  //Reset date time selection
  const handleCancelClick = () => {
    setShowModel(false);
    formik.setValues((v) => ({
      ...v,
      delivery_information: {
        ...v.delivery_information,
        delivery_date_time: "",
        delivery_time: "",
        delivery_date: null,
      },
    }));
    setMatrix([]);
  };

  //This function is used to handle the delivery date change
  const handleDeliveryDateChange = (data) => {
    //Set the timeslection dropdown to true
    setTimeslectionDropdown(true);
    setEnableTimeEdit(true);
    handleDateChange(data);
    //Get the store id from the billing info
    const storeId = formik.values.billing_info.zip_code_store_id;
    const selectedTime = moment(CUSTOM_DEFAULT_TIME, "HH:mm a").format("HH:mm");
    //Validate the delivery date selection
    validateDeliveryDateSelection(storeId, data, selectedTime);
  }

  return (
    <div className="row">
      <Warning
        btn1_title={"Continue"}
        btn2_title={"Cancel"}
        handleCancelClick={handleCancelClick}
        showModal={showModel}
        handleSubmitClick={() => setShowModel(false)}
        message={
          "You are placing an order that is outside this store’s operating hours."
        }
        message2={"Are you sure you want to continue?"}
        title={"Warning"}
        key={"date_selection_warning"}
      />
      <div className="col-4">
        <RadioBox
          //  we are manage fields using Order payment_method and order Type 
          disabled={isDisebled || active > 0 || formik.values.is_burq_order === 1}
          selectedValue={formik.values.delivery_information.order_type.toString()}
          label="Delivery Order"
          value="0"
          onChange={() => {
            setEnableTimeEdit(true);
            setMatrix([]);
            resetDeliveryInformation();
          }}
        />
        {
          (!formik?.values?.is_subscribe_order || module != "new-order") &&
          (
            <RadioBox
              //  we are manage fields using Order payment_method and order Type 
              disabled={isDisebled || isNonlocalZipcode || active > 0 || formik.values.is_burq_order === 1}
              selectedValue={formik.values.delivery_information.order_type.toString()}
              label="Pickup Order"
              value="1"
              labelClass={isNonlocalZipcode ? "d-none" : ""}
              onChange={() => {

                //const storeId = formik.values.billing_info.zip_code_store_id || 1;

                setMatrix([]);
                setEnableTimeEdit(true);
                const deliveryStoreId = formik.values.billing_info.zip_code_store_id
                const AssignedStoreList = storeLists || []
                const checkIsDeliveryStoreAssigned = AssignedStoreList.find(store => store.id === deliveryStoreId)
                const storeId = (checkIsDeliveryStoreAssigned && deliveryStoreId) || AssignedStoreList[0].id || DEFAULT_STORE_ID
                // const storeInfo = config.storeList.find(store => store.id === storeId)
                // const paymentMethod = PAYMENT_METHOD_DETAIL[storeId] ? PAYMENT_METHOD_DETAIL[storeId] : PAYMENT_METHODS.PAYABLI
                const storeTimezone = config?.storeList?.find((store)=>store.id === storeId)?.timezone || DEFAULT_TIMEZONE;
                formik.setValues((v) => ({
                  ...v,
                  delivery_information: {
                    ...v.delivery_information,
                    is_local:1,
                    order_type: 1,
                    charge: 0,
                    upcharge_id: 0,
                    upcharge_amount: 0,
                    delivery_time: "",
                    delivery_date: null,
                    delivery_date_time: "",
                    delivery_type_id: 1,
                    delivery_type: config?.deliveryTypesList?.find((c) => c.id === 1)?.name ?? "",
                    delivery_time_id: null,
                    storeId: storeId
                  },
                  //PAYABLI
                  billing_info: {
                    ...v.billing_info,
                    zip_code_store_id: storeId,
                    payment_method: PAYMENT_METHOD_DETAIL[storeId] ? PAYMENT_METHOD_DETAIL[storeId] : PAYMENT_METHODS.PAYABLI
                  },
                  payabli_paypoint:  config?.storeList.find((store)=>store.id === storeId)?.payabli_paypoint,
                  payment_type: module === "edit-order" || module === "replace-order" ? v.payment_type : "",
                  orderTimezone: storeTimezone,
                  is_initial_load: false
                }));
              }}
            />
          )
        }

      </div>
      {
        formik.values.delivery_information.order_type && module != "edit-order" && !formik?.values?.is_subscribe_order ?
          <div className="col-4">
            <Select
              label="Select Store"
              value={formik.values.delivery_information.storeId}
              required={false}
              //  we are manage fields using Order payment_method and order Type 
              disabled={isDisebled || !formik.values.delivery_information.order_type}
              onChange={(data) => {
                const selectedDate = formik.values.delivery_information.delivery_date;
                const deliveryDateTime = formik.values.delivery_information.delivery_date_time;
                const pstTime = utcDateTimeToPSTTime(deliveryDateTime, formik?.values?.orderTimezone);
                const selectedTime = moment(pstTime,"HH:mm a").format("HH:mm")
                validateDeliveryDateSelection(data?.id, selectedDate, selectedTime);
                formik.setValues((v) => ({
                  ...v,
                  delivery_information: {
                    ...v.delivery_information,
                    storeId: v.cart_products.product_variation_storeIds.length > 0 ? v.cart_products.product_variation_storeIds[0] : data.id
                  },
                  //PAYABLI
                  billing_info: {
                    ...v.billing_info,
                    zip_code_store_id: data?.id,
                    payment_method: data?.paymentgateway
                  },
                  payabli_paypoint: data?.payabli_paypoint,
                  payment_type: module === "edit-order" || module === "replace-order" ? v.payment_type : "",
                  orderTimezone: data?.timezone || DEFAULT_TIMEZONE,
                  is_initial_load: false
                }));
                isvalidateNotAllowStoreOrder(data.paymentgateway, data?.payabli_paypoint, data?.id)
              }}
              options={storeLists || []}
            />
          </div>
          : <div className="col-4"></div>
      }
      <div className="col-2"></div>

      <div className="col-md-4">
        <DatePickerWithInput
          //  we are manage fields using Order payment_method and order Type 
          disabled={isDisebled || active > 0 || formik.values.is_burq_order === 1}
          label="Delivery Date"
          // blockDates={blockoutDates} // open when you want to check block out days
          blockDates={[]}
          tooltipDays={tooltipDays}
          value={
            formik.values.delivery_information.delivery_date
              ? moment(
                formik.values.delivery_information.delivery_date
              ).toDate()
              : null
          }
          onChange={(data) => {
            handleDeliveryDateChange(data)
          }}
          orderTimezone={formik?.values?.orderTimezone}
        />
      </div>
      <div className="col-md-4 mt-1">
        <Select
          //  we are manage fields using Order payment_method and order Type 
          disabled={isDisebled || active > 0 || formik.values.is_burq_order === 1}
          options={formik.values.is_subscribe_order && module === "new-order" ? config.deliveryTypesList.filter(elem => elem.id === 2) : config.deliveryTypesList}
          label="Delivery Type"
          onChange={handleDeliveryType}
          value={formik.values.delivery_information.delivery_type_id}
        />
      </div>
      <div className="col-md-4">
        {!enableTimeEdit && (
          <TextField
            className="w-100"
            disabled
            label={
              formik.values.delivery_information.order_type === 0
                ? "Delivery time"
                : "Pickup time"
            }
            value={
              formik.values.delivery_information.order_type === 0
                ? formik.values.delivery_information.delivery_time_id === -1
                  ? "Custom"
                  : `${formik.values.delivery_information.delivery_time_type
                  }  ${formik.values.delivery_information.delivery_time_type ===
                    "Anytime"
                    ? ""
                    : utcDateTimeToPSTTime(
                      formik.values.delivery_information
                        .delivery_date_time,
                      formik?.values?.orderTimezone
                    )
                  }`
                : `${utcDateTimeToPSTTime(
                  formik.values.delivery_information.delivery_date_time,
                  formik?.values?.orderTimezone
                )}`
            }
            variant="standard"
          />
        )}
        {enableTimeEdit && (
          <>
            {/* we are manage fields using Order payment_method and order Type  */}
            {isDisebled || formik.values.delivery_information.order_type === 1 ? (
              <div style={{paddingTop: "20px",marginBottom: "16px",}}>
              <Datetime
                value={(() => {
                  const timeString = utctimeToPSTTime(
                    (formik.values?.delivery_information?.delivery_date_time) ? formik.values.delivery_information.delivery_date_time : null, 
                    formik.values.delivery_information.delivery_date, 
                    formik.values.delivery_information.delivery_time, 
                    formik?.values?.orderTimezone
                  );
                  // Convert string back to moment object for react-datetime
                  return timeString ? moment(timeString, "hh:mm a") : null;
                })()}
                className={classes.time}
                dateFormat={false}
                input={true}
                inputProps={{ placeholder: "Select your pickup time" }}
                onChange={(data) => {
                  handleTimeChange(data);
                  if(typeof data !== 'string'){
                    const storeId = formik.values.billing_info.zip_code_store_id;
                    const pickupTime = data?.format('HH:mm');
                    const selectedDate = formik.values.delivery_information.delivery_date;
                    validateDeliveryDateSelection(storeId, selectedDate, pickupTime);
                  }
                }}
              />
              </div>
            ) : (
              <>
                {timeslectionDropdown ? (
                  <Select
                    label="Calculating..."
                    value={timeslectionDropdown ? null : formik.values.delivery_information.delivery_time_id}
                    onChange={""}
                    options={[]}
                  />
                ) : (
                  <Select
                    label="Delivery Time"
                    value={formik.values.delivery_information.delivery_time_id}
                    onChange={handleDeliveryMatrix}
                    options={matrix}
                  />
                )}
              </>
            )}
          </>
        )}
      </div>
      {formik.values.delivery_information.delivery_time_id === -1 && (
        <>
          <div className="col-md-4">
            <Select
              value={formik.values.delivery_information.delivery_time_type}
              label="Delivered By"
              onChange={(data) => {
                handleDeliveredBy(data.id);
                // formik.setValues((v) => ({
                //   ...v,
                //   delivery_information: {
                //     ...v.delivery_information,
                //     delivery_time_type: data.id,
                //   },
                // }));
              }}
              options={
                formik.values.delivery_information.address_type_id > 2
                  ? orderDeliveryWithOutAnytime
                  : orderDelivery
              }
              id="delivery_time_type"
              error={
                formik.touched?.delivery_information?.delivery_time_type &&
                Boolean(formik.errors?.delivery_information?.delivery_time_type)
              }
            />
          </div>
          {formik.values.delivery_information.delivery_time_type !==
            "Anytime" && (
              <div className="col-md-4" style={{
                paddingTop: "16px",
                marginBottom: "16px",
              }}>
                <Datetime
                  value={(() => {
                    const timeString = utctimeToPSTTime(
                      (formik.values?.delivery_information?.delivery_date_time) ? formik.values.delivery_information.delivery_date_time : null, 
                      formik.values.delivery_information.delivery_date, 
                      formik.values.delivery_information.delivery_time, 
                      formik?.values?.orderTimezone
                    );
                    // Convert string back to moment object for react-datetime
                    return timeString ? moment(timeString, "hh:mm a") : null;
                  })()}
                  className={classes.time}
                  dateFormat={false}
                  input={true}
                  inputProps={{ placeholder: "Select your delivery time" }}
                  onChange={handleTimeChange}
                />
              </div>
            )}

          <div className="col-md-4">
            {/* <TextField
              value={formik.values.delivery_information.charge}
              className={classes.time}
              dateFormat={false}
              input={true}
              inputProps={{ placeholder: "Add Delivery Charge" }}
              onChange={handleDeliveryChargeChange}
            /> */}
            <Text
              type="text"
              label="Delivery Charge"
              // disabled
              value={tempCharge.toString()}
              required={true}
              onChange={(value) => {
                if (/^[0-9]*(\.[0-9]*)?$/.test(value)) {
                  // handleDeliveryChargeChange(value);
                  setTempCharge(value);
                }
              }}
            />
          </div>
        </>
      )}
      {formik.values.is_subscribe_order === 1 && (
        <div className="col-md-4">
          <Select
            disabled={module === "new-order" ? false : true}
            options={config.frequencyList}
            value={formik.values.delivery_information.frequency}
            label="Subscription Type"
            onChange={(data) => {
              formik.setValues((v) => ({
                ...v,
                delivery_information: {
                  ...v.delivery_information,
                  frequency: data.id
                }
              }));
            }}
          />
        </div>
      )}
      {show.two_field && (
        <>
          <div className="col-md-4">
            <TextField
              disabled={active > 0}
              className="w-100 my-2"
              value={formik.values.delivery_information.shop_code}
              onChange={formik.handleChange}
              id="delivery_information.shop_code"
              error={
                formik.touched?.delivery_information?.shop_code &&
                Boolean(formik.errors?.delivery_information?.shop_code)
              }
              onBlur={formik.handleBlur}
              label="Shop Code"
              variant="standard"
            />
          </div>
          {show.all_field && (
            <div className="col-md-4">
              <TextField
                disabled={active > 0}
                className="w-100 my-2"
                value={formik.values.delivery_information.shop_name}
                onChange={formik.handleChange}
                id="delivery_information.shop_name"
                error={
                  formik.touched?.delivery_information?.shop_name &&
                  Boolean(formik.errors?.delivery_information?.shop_name)
                }
                onBlur={formik.handleBlur}
                label="Shop Name"
                variant="standard"
              />
            </div>
          )}
          {show.all_field && (
            <div className="col-md-4">
              <TextField
                disabled={active > 0}
                className="w-100 my-2"
                value={formik.values.delivery_information.person_name}
                onChange={formik.handleChange}
                id="delivery_information.person_name"
                error={
                  formik.touched?.delivery_information?.person_name &&
                  Boolean(formik.errors?.delivery_information?.person_name)
                }
                onBlur={formik.handleBlur}
                label="Person Name"
                variant="standard"
              />
            </div>
          )}
          <div className="col-md-4">
            <TextField
              disabled={active > 0}
              className="w-100 my-2"
              value={formik.values.delivery_information.external_order_number}
              onChange={formik.handleChange}
              id="delivery_information.external_order_number"
              error={
                formik.touched?.delivery_information?.external_order_number &&
                Boolean(
                  formik.errors?.delivery_information?.external_order_number
                )
              }
              onBlur={formik.handleBlur}
              label="External Order Number"
              variant="standard"
            />
          </div>
          {show.all_field && (
            <div className="col-md-4">
              <TextField
                disabled={active > 0}
                className="w-100 my-2"
                value={formik.values.delivery_information.phone_number}
                onChange={formik.handleChange}
                id="delivery_information.phone_number"
                error={
                  formik.touched?.delivery_information?.phone_number &&
                  Boolean(formik.errors?.delivery_information?.phone_number)
                }
                onBlur={formik.handleBlur}
                label="Phone Number"
                variant="standard"
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Delivery;
